import { Counter } from '@/components/form/fields/number/Counter';
import { CategoryIcons } from '@/components/icons/CategoryIcons';
import { Picture } from '@/components/image/Image';
import DaasTableRowCell from '@/components/table/DaasTableRowCell';
import EllipsizedWithTooltip from '@/components/tooltip/EllipsizedWithTooltip';
import { Product } from '@/services/api/contracts/catalog/types';
import { FC, FunctionComponent } from 'react';
import { StandardisedProduct } from './StockProvisionPage';

interface Props {
  data: StandardisedProduct;
  onChangeCallback: (productId: string, count: number) => void;
}

interface ProductImageProps {
  product: Product;
  height: number;
  width: number;
}

const ProductImage: FC<ProductImageProps> = ({ product, height, width }) => {
  return product.imageUri?.id ? (
    <Picture image={product.imageUri} containerHeight={height} containerWidth={width}></Picture>
  ) : (
    <div className="w-full [&_svg]:w-[100%] [&_svg]:h-[100%]" style={{ height }}>
      {CategoryIcons[product.category.description]}
    </div>
  );
};

export const StockProvisionStandardProductTableRow: FunctionComponent<Props> = ({ data, onChangeCallback }) => {
  const product = data.product;

  const specs = product.propertyBag.properties?.map(spec => spec.text).join(' / ');

  return (
    <>
      <DaasTableRowCell>
        <div className="flex flex-row space-x-5 w-full h-[70px] items-center">
          <div className="w-[125px] h-full flex items-center justify-center">
            <ProductImage product={product} height={70} width={125} />
          </div>
          <div className="flex-1">
            <p className="text-lg">{product.manufacturer.name}</p>
            <p className="text-2xl font-semibold">{product.name}</p>
            <EllipsizedWithTooltip
              // Calc is full viewport - LHP / total table fraction to get value of 1fr
              // Since device table row is 1fr
              className="max-w-[calc((100vw-25rem)/1.6)]"
              id={`${product.id}-specs`}
              elementText={specs}
              tooltipText={specs}
            />
          </div>
        </div>
      </DaasTableRowCell>
      <DaasTableRowCell>{product.productId}</DaasTableRowCell>
      <DaasTableRowCell>
        <Counter
          className="flex justify-center py-2"
          id={product.id}
          value={data.count}
          allowManualChange={true}
          min={0}
          onChange={value => {
            onChangeCallback(product.id, value);
          }}
        />
      </DaasTableRowCell>
    </>
  );
};
